"use strict";

const NetworkFormCtrl = function (CRUDService, Notification, config, $stateParams, $state) {
  var ctrl = this,

  initModel =  {
    name: ""
  };

  ctrl.$onInit = function(){    
    ctrl.model = $stateParams.item || initModel;
  };

  ctrl.add = function(form){
    if (form.$valid){
      CRUDService.save(ctrl.model, config.urls.networks, 'name,asc').then(function(){
        ctrl.model = initModel;
        $state.go('main.settings.network');
      }, function(){
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };
};

NetworkFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$state'];

module.exports = {
  template: require('./networks-form.html'),
  controller: NetworkFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/form-network/form-network.component.js